<template>
  <div class="index">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="跟进安排" name="first">
        <el-form ref="registerRef" label-width="120px" :model="childInfo">
          <el-row>
            <el-col :span="12">
              <el-form-item label="手机号:" prop="userPhone">
                <el-input
                  v-model="childInfo.userPhone"
                  style="width: 270px"
                  placeholder=""
                  readonly="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生日:" prop="birthday">
                <el-date-picker
                  style="width: 200px"
                  v-model="childInfo.birthday"
                  type="date"
                  placeholder="选择日期"
                  disabled
                >
                </el-date-picker>
                <!-- value-format="timestamp" -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="会员姓名:" prop="name">
                <el-input
                  style="width: 270px"
                  v-model="childInfo.name"
                  readonly="true"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="性别:" prop="gender">
                <el-select
                  disabled
                  v-model="childInfo.gender"
                  placeholder="请选择"
                  style="width: 200px"
                >
                  <el-option
                    v-for="item in genderOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="小名:" prop="petName">
                <el-input
                  style="width: 270px"
                  v-model="childInfo.petName"
                  readonly="true"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="跟进时间:" prop="birthday">
                <el-date-picker
                  style="width: 270px"
                  v-model="childInfo.birthday"
                  type="date"
                  placeholder="选择日期"
                  value-format="timestamp"
                >
                </el-date-picker>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <el-col v-for="(cur, curIx) in currentHasWorkersList" :key="curIx">
              <el-form-item label="跟进人:">
                <el-select
                  v-model="cur.id"
                  placeholder="请选择"
                  style="width: 240px"
                >
                  <el-option
                    v-for="item in workersList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    :disabled="
                      cur.id == item.id ||
                      currentHasWorkersList
                        .map((mk) => {
                          return Number(mk.id);
                        })
                        .includes(item.id)
                        ? true
                        : false
                    "
                  >
                  </el-option>
                </el-select>
                <i
                  v-if="currentHasWorkersList.length - 1 == curIx"
                  class="el-icon-circle-plus"
                  style="font-size: 20px; cursor: pointer"
                  @click="handleAddPerson"
                ></i>
                <i
                  v-if="currentHasWorkersList.length > 1"
                  class="el-icon-remove"
                  style="font-size: 20px; cursor: pointer; margin-left: 15px"
                  @click="handleDelPerson(curIx)"
                ></i>
              </el-form-item>
            </el-col>
            <el-col :span="12"></el-col>
          </el-row>
        </el-form>
        <div class="dialog-footer-1">
          <el-button @click="handleCancel">取消</el-button>
          <el-button type="primary" @click="handleUpdate()">保存</el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane label="跟进详情" name="second">
        <!-- <table border class="index-table">
          <tr>
            <td class="index-table-label">家长姓名</td>
            <td>张三达</td>
            <td class="index-table-label">手机号</td>
            <td>11111111111</td>
            <td class="index-table-label">会员姓名</td>
            <td>刘大大</td>
          </tr>
          <tr>
            <td class="index-table-label">孩子小名</td>
            <td>张三达</td>
            <td class="index-table-label">孩子性别</td>
            <td>男</td>
            <td class="index-table-label">生日</td>
            <td>2019-02-05</td>
          </tr>
        </table> -->
        <div class="index-steps" @scroll="checkScroll" ref="scrollContent">
          <el-steps direction="vertical">
            <el-step v-for="(info, ix) in recordList" :key="ix"
              >>
              <img
                class="index-steps-icon"
                slot="icon"
                :src="
                  ix == 0
                    ? require('@/assets/icons/xa.png')
                    : require('@/assets/icons/xb.png')
                "
                alt=""
              />
              <div slot="description">
                <p>
                  跟进时间：{{ info.recordDateTime }} 跟进人：{{
                    info.followWorkerName
                  }}
                </p>
                <!-- <p>跟进内容：这里是跟进内容</p>
                <p>客户跟进</p> -->
                <p>{{ info.feedbackResult }}</p>
                <i
                  v-if="info.feedbackAudio"
                  style="font-size: 22px; color: #0e6fb8"
                  class="el-icon-microphone"
                  @click="clickAudio(info.feedbackAudio)"
                ></i>
              </div>
            </el-step>
          </el-steps>
        </div>
      </el-tab-pane>
    </el-tabs>
    <worker-word
      :key="refreshWord"
      :word-type="wordType"
      :t-data="tData"
      :show="showWordDlg"
      @onWorkerWord="handleWord"
    ></worker-word>
    <!-- <el-dialog
      title="口令"
      :visible.sync="visibleCommand"
      width="500px"
      center
      append-to-body
    >
      <el-form ref="registerRefV" label-width="120px">
        <el-form-item label="输入口令:" prop="userPhone">
          <el-input
            style="width: 270px"
            placeholder=""
            readonly="true"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleCommand = false">取 消</el-button>
        <el-button type="primary" @click="onBtnhandleUpdate()">确 定</el-button>
      </span>
    </el-dialog> -->

    <template v-if="audioDialog">
      <el-dialog
        title="音频文件"
        width="500px"
        :visible.sync="audioDialog"
        center
        :modal="false"
      >
        <audioDialog ref="audioDialogRef" />
      </el-dialog>
    </template>
  </div>
</template>

<script>
import audioDialog from "@/components/audioDialog";
import commonUtils from "@/utils/commonUtils";
import messageUtils from "@/utils/messageUtils";
import globaldata from "@/utils/globaldata";
import { adminJobPlanPlanWorksGET } from "@/api/vtwonewcontent";
import {
  clientAddFollow,
  adminFollowrecordList,
} from "@/api/PotentialCustomers";
import WorkerWord from "@/components/WorkerWord/WorkerWord";
export default {
  components: { WorkerWord,audioDialog },
  props: {
    childInfo: Object,
  },
  data() {
    return {
      currentHasWorkersList: [{ id: null }], //跟进人列表
      workersList: [],
      genderOptions: [
        {
          label: 0,
          label: "男",
        },
        {
          value: 1,
          label: "女",
        },
      ],
      activeName: "first",
      visibleCommand: false,
      refreshWord: "",
      showWordDlg: false,
      wordType: '',
      tData: '',
      logListPageNum: 1,
      logListPageSize: 10,
      logListPageTotalPage: 0,
      recordList: [],
      audioDialog: false,

    };
  },

  mounted() {
    this.adminJobPlanPlanWorksAxios();
  },
  methods: {
    clickAudio(val) {
      this.audioDialog = true;

      this.$nextTick(() => {
        this.$refs.audioDialogRef.audio = val;
      });
    },
    //获取员工列表
    async adminJobPlanPlanWorksAxios() {
      const response = await adminJobPlanPlanWorksGET({
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      });
      if (response.code === 20000) {
        this.workersList = response.data;
      }
    },
    handleAddPerson() {
      let self = this;
      if (self.currentHasWorkersList.length) {
        try {
          self.currentHasWorkersList.forEach((item) => {
            if (!item.id) {
              self.$message.warning("请先选择跟进人");
              throw new Error("Something bad happened.");
            }
          });
        } catch (error) {
          if (error.message === "Something bad happened.") throw error;
        }
        self.currentHasWorkersList.push({ id: null });
      } else {
        self.currentHasWorkersList.push({ id: null });
      }
    },
    handleDelPerson(index) {
      this.$delete(this.currentHasWorkersList, index);
    },
    handleUpdate() {
      let param = {
        type: 1,
        userId: this.childInfo.userId,
        publisher: globaldata.getAdminStore().id,
        workers: this.currentHasWorkersList.map((item) => {
          return item.id;
        }),
      };
      this.doRefreshWord(true, 1, param);
    },
    handleWord(wordType, tData) {
      if (wordType == 1) {
        this.doBuyExpCard(tData);
      }
    },
    doBuyExpCard(param) {
      clientAddFollow(param).then((response) => {
        this.closeWordDlg();
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          messageUtils.errorMsg(this, response.message);
          return;
        }
        messageUtils.successMsg(this, response.message);
        this.$emit("onBtnhandleUpdate");
      });
    },
    doRefreshWord(show, wordType, tData) {
      this.tData = tData;
      this.wordType = wordType;

      this.showWordDlg = show;
      this.refreshWord = new Date().getTime();
    },
    closeWordDlg() {
      this.wordTitle = "";
      this.wordType = 0;
      this.showWordDlg = false;
      this.refreshWord = new Date().getTime();
    },

    handleClick(tab, event) {
      console.log(tab, event);
      console.log(this.activeName, "this.activeName", this.childInfo);
      if (this.activeName == "second") {
        if (this.childInfo.masterId) {
          this.getFollowRecordAxios();
        }
      }
    },
    // 获取跟进记录详情
    async getFollowRecordAxios() {
      let params = {
        pageNum: this.logListPageNum,
        pageSize: this.logListPageSize,
        masterId: this.childInfo.masterId,
      };
      const response = await adminFollowrecordList(params);
      if (response.code == 20000) {
        let data = response.data;
        this.recordList =
          this.logListPageNum == 1
            ? data.list
            : this.recordList.concat(data.list);
        this.logListPageTotalPage = data.totalPage;
      }
    },
    // 检查滚动并触发加载更多数据
    checkScroll() {
      const content = this.$refs.scrollContent;
      if (
        content.scrollHeight - content.clientHeight - content.scrollTop < 20 &&
        this.logListPageTotalPage > this.logListPageNum
      ) {
        this.logListPageNum++; // 增加页数
        this.getFollowRecordAxios();
      }
    },
    handleCancel() {
      this.$emit("onBtnCancel");
    },

    onBtnhandleUpdate() {
      this.visibleCommand = false;
      this.$emit("onBtnhandleUpdate");
    },
  },
};
</script>

<style lang="scss" scoped>
.index {
  &-table {
    width: 100%;
    border-collapse: collapse;
    border-color: #e4e1e1;
    tr {
      td {
        text-align: center;
        padding-top: 10px;
        padding-bottom: 10px;
      }
    }
    &-label {
      background-color: #e9e1e1;
    }
  }
  &-steps {
    margin-top: 20px;
    /deep/ .el-step__description {
      color: #333333;
    }
    /deep/ .el-step__line {
      background: #b6b3b3;
    }
    &-icon {
      width: 25px;
      height: 25px;
    }
    /deep/ .el-step__icon.is-text {
      border: none;
    }
  }
  /deep/ .el-input.is-disabled .el-input__inner {
    background: #ffffff;
  }
}
/deep/ .el-dialog--center {
  border: 2px solid #d0d0d0;
  border-radius: 10px;
}
/deep/ .el-dialog__header {
  border-radius: 10px;
  background: #f0f7ff;
}
</style>



// WEBPACK FOOTER //
// src/views/user_child/components/arrangeUpdateInfo.vue